const mapStateToProps = (state)=>{
    // const geoObjs = state?.api?.geoObjs;
    // const getGeoObj = state?.service?.Api?.getGeoObj;
    // const selectedGeoObjArray = state?.ui?.selectedGeoObjArray;
    const {
        api:{
            geoObjRoute, 
        }={},
        route:{
            routeSettingsArr,
            paletteStatus,
        }={},
        service:{
            Route:{
                updateRouteSettingsArr,
                deleteRoute,
            }={}
        }={}
    } = state;
    return {
        geoObjRoute,
        routeSettingsArr,
        paletteStatus,
        updateRouteSettingsArr,
        deleteRoute,
    }
}

export default mapStateToProps